import { render, staticRenderFns } from "./OfficeCustomers.vue?vue&type=template&id=5d7b8d50&scoped=true&"
import script from "./OfficeCustomers.vue?vue&type=script&lang=js&"
export * from "./OfficeCustomers.vue?vue&type=script&lang=js&"
import style0 from "./OfficeCustomers.vue?vue&type=style&index=0&id=5d7b8d50&lang=scss&scoped=true&"
import style1 from "./OfficeCustomers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7b8d50",
  null
  
)

export default component.exports